import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { api } from '../../services/api';
import { useTranslation } from 'react-i18next';
import AuthLayout from '../../layouts/AuthLayout';

const VerifyEmail: React.FC = () => {
  const { t } = useTranslation('auth');
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      return;
    }

    api.post('/customer/verify-email', { token })
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [searchParams]);

  return (
    <AuthLayout>
      <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border dark:border-slate-700 p-6 sm:p-8 text-center">
        {status === 'loading' && (
          <>
            <div className="flex justify-center mb-4">
              <Loader2 className="h-10 w-10 text-primary animate-spin" />
            </div>
            <p className="text-sm text-muted-foreground">{t('verify_email.verifying')}</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 rounded-full bg-emerald-50 dark:bg-emerald-900/30 flex items-center justify-center">
                <CheckCircle className="h-8 w-8 text-emerald-600" />
              </div>
            </div>
            <h2 className="text-2xl font-bold mb-2">{t('verify_email.success_title')}</h2>
            <p className="text-sm text-muted-foreground mb-6">{t('verify_email.success_message')}</p>
            <Link to="/login">
              <Button className="w-full">{t('verify_email.signin_button')}</Button>
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 rounded-full bg-red-50 dark:bg-red-900/30 flex items-center justify-center">
                <XCircle className="h-8 w-8 text-red-600" />
              </div>
            </div>
            <h2 className="text-2xl font-bold mb-2">{t('verify_email.error_title')}</h2>
            <p className="text-sm text-muted-foreground mb-6">{t('verify_email.error_message')}</p>
            <Link to="/login">
              <Button className="w-full">{t('verify_email.signin_button')}</Button>
            </Link>
          </>
        )}
      </div>
    </AuthLayout>
  );
};

export default VerifyEmail;
